module.exports = {
  access: localStorage.getItem("access"),
  rootApi: process.env.REACT_APP_ROOT_API,
};
